import { explicitMaybe } from '@execonline-inc/decoders';
import { array, boolean, dateISO, Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';
import { License } from '../Types';
import {
  Collection,
  Member,
  ParticipantOptions,
  ParticipantOptionsResource,
  UserGroupWithAssociations,
} from './Types';

const collectionDecoder: Decoder<Collection> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('learningDesignCount', field('learning_design_count', number));

const memberDecoder: Decoder<Member> = succeed({})
  .assign('id', field('id', number))
  .assign('firstName', field('first_name', string))
  .assign('lastName', field('last_name', string))
  .assign('email', field('email', string));

const groupDecoder: Decoder<UserGroupWithAssociations> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('organization', field('organization', string))
  .assign('organizationId', field('organization_id', number))
  .assign('memberCount', field('member_count', number))
  .assign('assignedLicenseCount', field('assigned_license_count', number))
  .assign('assignedLicenseIds', field('assigned_license_ids', array(number)))
  .assign('associatedLicenseIds', field('associated_license_ids', array(number)))
  .assign('collections', field('collections', array(collectionDecoder)))
  .assign('members', field('members', array(memberDecoder)));

const licenseDecoder: Decoder<License> = succeed({})
  .assign('id', field('id', number))
  .assign('licenseName', field('license_name', explicitMaybe(string)))
  .assign('licenseTypeName', field('license_type_name', string))
  .assign('quantityAvailable', field('quantity_available', number))
  .assign('startOn', field('start_on', dateISO))
  .assign('endOn', field('end_on', dateISO));

const participantOptionsDecoder: Decoder<ParticipantOptions> = succeed({})
  .assign('userGroups', field('user_groups', array(groupDecoder)))
  .assign('licenses', field('licenses', array(licenseDecoder)))
  .assign('canAddAsAuditor', field('can_add_as_auditor', boolean));

export const participantOptionsResourceDecoder: Decoder<ParticipantOptionsResource> =
  resourceDecoder(participantOptionsDecoder);
